import { IAumMenuItem } from '../../../../aumico-lib-core-fe/src/lib';
import { MenuAction } from '../enums/menu-action.enum';
import { isFliNumberingDisable } from '../type-guards/type-guards';
import { Item } from './menu-item.class';

export class MenuItemList {
    items: IAumMenuItem[];
    constructor() {
        this.items = [];
    }
    addEdit(): typeof this {
        const menuItem: IAumMenuItem = {
            icon: 'aumico_edit_icon.svg',
            caption: 'aumico_templates_group_account_mapping_menu_edit',
            action: MenuAction.EDIT,
            disabled: false,
        };
        this.items.push(menuItem);
        return this;
    }
    addEditProfitManually(): typeof this {
        const menuItem: IAumMenuItem = {
            icon: 'aumico_edit_icon.svg',
            caption: 'aumico_templates_group_account_mapping_menu_edit_profit_manually',
            action: MenuAction.EDIT_PROFIT_MANUALLY,
            disabled: false,
        };
        this.items.push(menuItem);
        return this;
    }
    addBalanceSwitchAccount(): typeof this {
        const menuItem: IAumMenuItem = {
            icon: 'aumico_account_split_icon.svg',
            caption: 'aumico_templates_group_account_mapping_switch_account',
            action: MenuAction.SWITCH_ACCOUNT,
            disabled: false,
        };
        this.items.push(menuItem);
        return this;
    }
    addAccount(): typeof this {
        const menuItem: IAumMenuItem = {
            icon: 'aumico_add_icon.svg',
            caption: 'aumico_templates_group_account_mapping_add_account',
            action: MenuAction.ADD_ACCOUNT,
            disabled: false,
        };
        this.items.push(menuItem);
        return this;
    }
    addDuplicateAccount(): typeof this {
        const menuItem: IAumMenuItem = {
            icon: 'aumico_add_icon.svg',
            caption: 'aumico_templates_group_account_mapping_duplicate_account',
            action: MenuAction.DUPLICATE_ACCOUNT,
            disabled: false,
        };
        this.items.push(menuItem);
        return this;
    }
    addSubTotal(): typeof this {
        const menuItem: IAumMenuItem = {
            icon: 'aumico_add_icon.svg',
            caption: 'aumico_templates_group_account_mapping_add_sub_total',
            action: MenuAction.ADD_SUBTOTAL,
            disabled: false,
        };
        this.items.push(menuItem);
        return this;
    }
    addGroup(): typeof this {
        const menuItem: IAumMenuItem = {
            icon: 'aumico_add_icon.svg',
            caption: 'aumico_templates_group_account_mapping_add_group',
            action: MenuAction.ADD_GROUP,
            disabled: false,
        };
        this.items.push(menuItem);
        return this;
    }
    addInsertEmptyRowAbove(): typeof this {
        const menuItem: IAumMenuItem = {
            icon: 'aumico_insert_empty_spacing_above_icon.svg',
            caption: 'aumico_templates_group_account_mapping_add_empty_space_above',
            action: MenuAction.INSERT_SPACING_ABOVE,
            disabled: false,
        };
        this.items.push(menuItem);
        return this;
    }
    addInsertEmptyRowBelow(): typeof this {
        const menuItem: IAumMenuItem = {
            icon: 'aumico_insert_empty_spacing_below_icon.svg',
            caption: 'aumico_templates_group_account_mapping_add_empty_space_below',
            action: MenuAction.INSERT_SPACING_BELOW,
            disabled: false,
        };
        this.items.push(menuItem);
        return this;
    }
    addInsertHeaderAbove(): typeof this {
        const menuItem: IAumMenuItem = {
            icon: 'aumico_insert_header_above_icon.svg',
            caption: 'aumico_templates_group_account_mapping_add_header_above',
            action: MenuAction.INSERT_HEADER_ABOVE,
            disabled: false,
        };
        this.items.push(menuItem);
        return this;
    }
    addInsertHeaderBelow(): typeof this {
        const menuItem: IAumMenuItem = {
            icon: 'aumico_insert_header_below_icon.svg',
            caption: 'aumico_templates_group_account_mapping_add_header_below',
            action: MenuAction.INSERT_HEADER_BELOW,
            disabled: false,
        };
        this.items.push(menuItem);
        return this;
    }
    toggleFliNumbering(item: Item = {} as Item): typeof this {
        const menuItem: IAumMenuItem = {
            icon: isFliNumberingDisable(item) ? 'aumico_add_icon.svg' : 'interface-remove-circle.svg',
            caption: isFliNumberingDisable(item)
                ? 'aumico_templates_group_account_mapping_fli_enable_numbering'
                : 'aumico_templates_group_account_mapping_fli_disable_numbering',
            action: isFliNumberingDisable(item) ? MenuAction.ENABLE_FLI_NUMBERING : MenuAction.DISABLE_FLI_NUMBERING,
            disabled: false,
        };
        this.items.push(menuItem);
        return this;
    }

    isDisabled(): typeof this {
        const lastMenuItem = this.items.pop();
        lastMenuItem.disabled = true;
        this.items.push(lastMenuItem);
        return this;
    }
}
